export const PERFORMANCE_TIPS = [
  {
    icon: 'itaufonts_educacao_uso_consc',
    description:
      'Uma boa descrição do seu carro é importante para atrair mais compradores. Capriche na sua.'
  },
  {
    icon: 'itaufonts_maquina_fotografica',
    description:
      'Anúncios com foto chamam mais atenção dos compradores. Publique seu anúncio com, ao menos, 4 fotos.'
  },
  {
    icon: 'itaufonts_consorcio',
    description:
      'Torne o seu anúncio mais atraente cadastrando os opcionais e acessórios do seu carro.'
  }
];
